import type { CSSProperties } from 'react';

export function displayedPlayerGeometry(element: HTMLElement | null) {
  const bounds = element?.getBoundingClientRect();
  return bounds && bounds.width > 0 && bounds.height > 0
    ? { x: bounds.left, y: bounds.top, width: bounds.width, height: bounds.height } : {};
}

/** Fit the displayed player panel without rewriting the user's saved drag/resize geometry. */
export function playerWindowGeometry(state: { x: number; y: number; width: number; height: number; collapsed: boolean },
  minimum: { width: number; height: number }): CSSProperties {
  const height = state.collapsed ? 50 : state.height;
  const widthCss = `min(${state.width}px, calc(100vw - 16px))`;
  const heightCss = `min(${height}px, calc(100vh - 16px))`;
  return {
    left: `clamp(8px, ${state.x}px, max(8px, calc(100vw - ${widthCss} - 8px)))`,
    top: `clamp(8px, ${state.y}px, max(8px, calc(100vh - ${heightCss} - 8px)))`,
    width: widthCss, height: state.collapsed ? 'auto' : heightCss,
    minWidth: `min(${minimum.width}px, calc(100vw - 16px))`,
    minHeight: state.collapsed ? undefined : `min(${minimum.height}px, calc(100vh - 16px))`,
  };
}
